"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _stylePropType = _interopRequireDefault(require("../style-prop-type"));

var _themePropType = _interopRequireDefault(require("../theme-prop-type"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _mapIndexed = _interopRequireDefault(require("../map-indexed"));

var _index = require("../index");

var _excluded = ["columns", "href", "theme"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  columns: _stylePropType["default"],
  href: _propTypes.string,
  theme: _themePropType["default"]
};

var GridElement = function GridElement(_ref) {
  var columns = _ref.columns,
      href = _ref.href,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var themeColumns = (0, _ramda.pathOr)([], ["grid", "columns"], theme);
  var columnsArray = (0, _index.normalizeArray)(columns, themeColumns.length);
  var columnWidths = (0, _react.useMemo)(function () {
    return (0, _mapIndexed["default"])(function (elem, index) {
      return columnsArray[index] / elem;
    }, themeColumns);
  }, [columnsArray, themeColumns]);
  var display = (0, _react.useMemo)(function () {
    return (0, _ramda.map)(function (elem) {
      return elem === 0 ? "none" : "inherit";
    }, columnWidths);
  }, [columnWidths]);
  var themeGutters = (0, _ramda.pathOr)([], ["grid", "gutters"], theme);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    as: href ? "a" : "div",
    display: display,
    flex: "0 0 auto",
    href: href,
    px: themeGutters,
    width: columnWidths
  }, props));
};

GridElement.propTypes = propTypes;
GridElement.displayName = "Modules.GridElement";

var _default = (0, _styledComponents.withTheme)(GridElement);

exports["default"] = _default;